// extracted by mini-css-extract-plugin
var _1 = "TableViewRegimeControl-moduleTableViewRegimeControl__eTvqE";
var _2 = "TableViewRegimeControl-moduleactive__IEq0j";
export { _1 as "TableViewRegimeControl", _2 as "active" }
